var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('admin-title',{attrs:{"title":_vm.$route.meta.name}}),_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}}),(_vm.activeName == 'site')?_c('Site'):_vm._e(),(_vm.activeName == 'storage')?_c('Storage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }